export {
  Input,
  InputSize,
  type InputType,
  type InputProps,
} from './Input';
